import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA, CUSTOM_ELEMENTS_SCHEMA, Injector } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import {  AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ConferenceListComponent } from './conference-list/conference-list.component';
import { provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { DatafilterPipe } from './shared/datafilter.pipe';
import { SearchdataPipe } from './shared/searchdata.pipe';
import { OktaAuth } from '@okta/okta-auth-js';
import { environment } from '../environments/environment';
import config from './app.config';
import { APP_BASE_HREF } from '@angular/common';
import { provideOktaAuth, withOktaConfig } from '@okta/okta-angular';

const oktaAuth = new OktaAuth(config.oidc);

@NgModule({ declarations: [
        AppComponent,
        ConferenceListComponent,
        DatafilterPipe,
        SearchdataPipe
    ],
    bootstrap: [
        AppComponent
    ],
    schemas: [
        CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA
    ], imports: [BrowserModule,
        AppRoutingModule,
        FormsModule], providers: [
        provideOktaAuth(withOktaConfig({
            oktaAuth,
            onAuthRequired: (oktaAuth: OktaAuth, injector: Injector) => {
                const triggerLogin = async () => {
                    await oktaAuth.signInWithRedirect({ originalUri: '/' });
                };
                if (!oktaAuth.authStateManager.getPreviousAuthState()?.isAuthenticated) {
                    triggerLogin();
                }
            }
        })),
        { provide: APP_BASE_HREF, useValue: environment.appBaseHref },
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class AppModule { }
